export const definedTranslation = {
  soon: {
    id: 'brands-page-soon-label',
    defaultMessage: 'Soon!',
  },
  new: {
    id: 'brands-page-new-label',
    defaultMessage: 'New',
  },
  collections: {
    title: {
      id: 'collections-block-title',
      defaultMessage: 'Featured collections',
    },
    button: {
      id: 'collections-block-all-button',
      defaultMessage: 'See All',
    },
  },
};
